import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6236ef36"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "evolution-arrow-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dot_element = _resolveComponent("dot-element");
  const _component_app_icon = _resolveComponent("app-icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$options.computedValue === 0 ? (_openBlock(), _createBlock(_component_dot_element, {
    key: 0,
    size: 4,
    color: "#ADADAD"
  })) : (_openBlock(), _createBlock(_component_app_icon, {
    key: 1,
    icon: $options.iconInfo.icon,
    color: $options.iconInfo.color,
    size: 12
  }, null, 8, ["icon", "color"]))]);
}